import { API_URL } from "env";

async function createSubcriptions(name: string,decs: string, price: number, features?: number[]) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                name,
                description: decs,
                price,
                features
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to create subscription");
        }
        return data || null;
    }
    catch (error) {
        console.error("Error creating subscription:", error);
        return null;
    }
}

export default createSubcriptions;